import './bootstrap'

import axios from 'axios'
import Vue from 'vue'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import Cookies from 'js-cookie'
import Vuex from 'vuex'
import * as VueGoogleMaps from 'vue2-google-maps'
import moment from 'moment-timezone'
import VueBase64FileUpload from 'vue-base64-file-upload'

import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import App from './App'
import routesList from './router'
import Tree from './components/Tree/Tree.vue'
import ButtonCopy from './components/ButtonCopy.vue'
import Emoji from './components/Emoji/EmojiComponent.vue'
import ButtonSave from './components/ButtonSave.vue'
import Tooltip from './components/Tooltip.vue'
import Pagination from './components/Pagination.vue'
import AutocompleteDirective from './directives/Autocomplete'
import redirect from './mixins/redirect'
import storeData from './store/store.js'
import buildCommandResult from './mixins/buildCommandResult'

import ImageUploader from './components/ImageUploader'
import VueToastr from 'vue-toastr'

import {NativeEventSource, EventSourcePolyfill} from 'event-source-polyfill'

import './filters/line-break'

// library.add(faSpinner, faUserSecret)

library.add(fas, fab)

Vue.use(Router)
Vue.use(BootstrapVue)
Vue.use(VeeValidate, {
	events: '',
})
Vue.use(Vuex)
Vue.use(VueToastr)
Vue.mixin(redirect)
Vue.mixin(buildCommandResult)

Vue.use(VueGoogleMaps, {
	load: {
		libraries: 'places', // This is required if you use the Autocomplete plugin
		key: 'AIzaSyDXF54G-z2WBs6MduYflp11r-wjvmzgIWk',
	},
	installComponents: !true,
})
Vue.component('google-map', VueGoogleMaps.Map)
Vue.component('google-marker', VueGoogleMaps.Marker)
Vue.component('google-place-input', VueGoogleMaps.PlaceInput)
Vue.component('google-autocomplete', VueGoogleMaps.Autocomplete)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('image-uploader', ImageUploader)

// console.log(VueGoogleMaps )

Vue.component('vue-base64-file-upload', VueBase64FileUpload)

Vue.component('button-copy', ButtonCopy)
Vue.component('tree', Tree)
Vue.component('emojiv2', Emoji)
Vue.component('tooltip', Tooltip)
Vue.component('pagination', Pagination)
Vue.component('save-button', ButtonSave)
Vue.directive('autocomplete', AutocompleteDirective)
Vue.directive('hide', {
	inserted: function(el) {
		if (el) {
			el.parentNode.removeChild(el)
		}
	},
})

Vue.config.productionTip = false

const router = new Router(routesList)

router.beforeEach((to, from, next) => {
	const token = localStorage.getItem('token')
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
	if (to.meta.is_login == true) {
		axios
			.get('/is_login')
			.then((response) => {
				if (response.data.status == 1) {
					store.commit('set_acl', {
						is_login: true,
					})
					axios.get('/service/get_list').then((response) => {
						if (response.data.status == 1) {
							store.commit('set_go_services', response.data.private)
							axios.get('/user/me').then(({data}) => {
								if (data.status == 1) {
									store.commit('set_acl', data.data)
									const token = localStorage.getItem('token')
									const header = {
										headers: {
											Authorization: 'Bearer ' + token,
										},
									}

									const streamUrl = `${process.env.VUE_APP_API_URL}/check-trained-examples`

									var es = new EventSourcePolyfill(streamUrl, header)

									es.addEventListener('message', (e) => {
										// this.$toastr.s('Command Trained Successfully')
										console.log(e)
									})
								}
								next()
							})
						}
					})
				} else {
					// ! not loged in
					next({
						path: '/user/login',
						query: {
							redirect: to.fullPath,
						},
					})
				}
			})
			.catch(() => {
				next({
					path: '/user/login',
					query: {
						redirect: to.fullPath,
					},
				})
			})
	} else {
		if (to.meta.is_login == false) {
			axios
				.get('/is_login')
				.then((response) => {
					if (response.data.status == 1) {
						store.commit('set_acl', {
							is_login: true,
						})
						next({
							path: '/',
						})
					}
				})
				.catch(() => next())
		} else {
			next()
		}
	}

	window.removeWedgitMessenger()
})

router.afterEach((to, from) => {
	if (to.name) {
		// document.title = to.name + " - Hansabot";
	}
})

const store = new Vuex.Store(storeData)

/* eslint-disable no-new */
const app = new Vue({
	router,
	store,
	render: (h) => h(App),
	data() {
		return {
			// Init Root Variables
			notifications: {},
			locale: (() => {
				let locale = Cookies.get('_al')
				if (['ar', 'en'].indexOf(locale) >= 0) {
					return locale
				}
				return 'en' // default locale
			})(),
			loader: false,
			msg_error: false,
			firstLoadFrame: true,
		}
	},
	methods: {
		notify(notification) {
			if (Array.isArray(notification)) {
				for (var i = 0; i < notification.length; i++) {
					this.notify(notification[i])
				}
			} else {
				this.notifications = {
					...this.notifications,
					[`n${window.id()}`]: notification,
				}
			}
		},

		timeAgo(time) {
			moment.updateLocale('en', {
				relativeTime: {
					future: 'in %s',
					past: '%s ago',
					s: 'Just now',
					ss: '%ds ago',
					m: '1m ago',
					mm: '%dm ago',
					h: '1h ago',
					hh: '%dh ago',
					d: '1d ago',
					dd: '%dd ago',
					M: 'a month ago',
					MM: '%d months ago',
					y: 'a year ago',
					yy: '%d years ago',
				},
			})

			return moment(time).fromNow(true)
		},

		localTime(time) {
			return moment(time + ' Z')
				.utc()
				.local()
				.format('MMMM Do YYYY, h:mm:ss A')
		},

		window() {
			return window
		},

		loadMessenger(scriptCode, config, callback) {
			window.loadMessenger(
				scriptCode,
				function(result) {
					if (window.is_func(callback)) {
						callback(result)
					}
				},
				function(err) {
					console.warn(err)
				}
			)
		},
	},
	watch: {
		msg_error(val) {
			if (val && val.length) {
				window.scrollTo(0, 0)
			}
		},
	},
	created() {
		// Add a “hook” to all AJAX requests on a page
		// addXMLRequestCallback((res) => {
		// 	if (res.status === 1) {
		// 		if (res.silent === 0) {
		// 			this.notify({
		// 				message: this.$t(res.msg || 'successfully updated'),
		// 				status: 'success',
		// 				area: 'topRight',
		// 			})
		// 		}
		// 	}
		// })
	},
}).$mount('#app')
